import { render, staticRenderFns } from "./TabsHead.vue?vue&type=template&id=6973401e&scoped=true&"
import script from "./TabsHead.vue?vue&type=script&lang=ts&"
export * from "./TabsHead.vue?vue&type=script&lang=ts&"
import style0 from "./TabsHead.vue?vue&type=style&index=0&id=6973401e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973401e",
  null
  
)

export default component.exports